"use client";

import { PageTypes } from "@lib/enums/PageTypes";
import { GenericPage } from "templates/GenericPage";
import { TwoColumnsPage } from "templates/TwoColumnPage";
import { serialize } from "@ungap/structured-clone";
import type {
    IPageGeneric,
    IPageTwoColumns,
    ISiteSettings,
} from "@contentful-api/types/contentful";

interface CustomerServiceLegalClientProps {
    page: IPageGeneric | IPageTwoColumns;
    siteSettings: ISiteSettings;
    pageType: PageTypes;
}

export default function CustomerServiceLegalClient({
    page,
    siteSettings,
    pageType,
}: CustomerServiceLegalClientProps) {
    const LayoutComponent = () => {
        if (pageType === PageTypes.GENERIC) {
            return <GenericPage page={page as IPageGeneric} siteSettings={siteSettings} />;
        }
        if (pageType === PageTypes.CUSTOMER_SERVICE) {
            // TODO: fix back and forward serializing
            const serializedPage = serialize(page);
            return <TwoColumnsPage serializedPage={serializedPage} />;
        }
    };
    return (
        <>
            <div hidden aria-hidden="true" data-testid="legalPagesSlug" />

            <LayoutComponent />
        </>
    );
}
